import React, { useEffect, useState } from "react";
import { Col, Row, Button, Card } from "react-bootstrap";
import { FaPlusCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { notify } from "./notify";
import { logout } from "../actions/userActions";
import Message from "./Message";
import VisitFollowupForm from "./VisitFollowupForm";
import FallRiskAssessment from "./FallRiskAssessment";
import FallRiskAssessmentAdult from "./FallRiskAssessmentAdult";
import MyLines from "./MyLines";
import NumericalPainScale from "./NumericalPainScale";
import { RiNurseLine } from "react-icons/ri";
import TextEditor from "./TextEditor";
import { AiOutlineSend } from "react-icons/ai";
import Loader from "./Loader";
import {
  codeBlue,
  criticalResultAlert,
  fallingEventContent,
  nursingCarePlan,
} from "../data/nurseForms";
import { FaPersonFalling } from "react-icons/fa6";
import { MdFormatListBulleted } from "react-icons/md";
import { TbActivityHeartbeat } from "react-icons/tb";
import { FaRemoveFormat } from "react-icons/fa";
import { IoNotifications } from "react-icons/io5";

const VisitNurseForm = ({
  visit,
  currentAge,
  patientVehicle,
  setVisitsVehicle,
  clinic,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [visitFollowups, setVisitFollowups] = useState([]);
  const [missedFollowups, setMissedFollowups] = useState([]);
  const [painScore, setPainScore] = useState(null);
  const [nurseNote, setNurseNote] = useState("");
  const [HDFS, setHDFS] = useState({});
  const [hendrich, setHendrich] = useState({});

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  // const FollowupItem = ({ i }) => {
  //   const isHiden = clinic?.clinicFollowups?.find(
  //     (t) => t._id.toString() === i.followupId.toString(),
  //   )?.isHide;
  //   return (
  //     <>
  //       {!isHiden && (
  //         <Col
  //           key={i._id}
  //           className="col-6 p-2"
  //         >{`${i.label}: ${i.value}`}</Col>
  //       )}
  //     </>
  //   );
  // };

  const dispatch = useDispatch();
  const addNurseSection = async () => {
    try {
      setLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.post(
        `/api/visits/${visit._id}/addVisitNurseSection`,
        {
          nurseId: userInfo._id,
          visitFollowups,
          HDFS,
          painScore,
          nurseNote,
          hendrich,
        },
        config,
      );
      if (data.message === "ADDED") {
        setVisitsVehicle();
        setLoading(false);
        notify({
          title: "Nurse Section Action",
          message: <p className="lead">Data added successfully.</p>,
          type: "success",
          duration: 4000,
        });
        setVisitFollowups([]);
        setHDFS("");
        setPainScore("");
        setNurseNote("");
      }
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      setError(message);
    }
  };

  const handleClear = () => {
    if (window.confirm("You will delete all text. Are you sure?")) {
      setNurseNote("");
    }
  };
  useEffect(() => {
    setMissedFollowups(
      clinic?.clinicFollowups
        ?.filter((t) => !t.isHide)
        ?.filter(
          (f) =>
            !visitFollowups.find(
              (ft) => ft.followupId.toString() === f._id.toString(),
            ),
        ),
    );
  }, [visitFollowups]);
  const deleteItem = (id) => {
    setVisitFollowups(visitFollowups.filter((t) => t.followupId !== id));
  };

  return (
    <div className="my-3">
      <h4
        className="text-center text-white p-4"
        style={{ backgroundColor: "#54B4D3" }}
      >
        {" "}
        <RiNurseLine /> Nurse Section
      </h4>

      <div className="px-3">
        {/* ================= FALL RISK SCORE =================  */}

        {currentAge?.years < 18 ? (
          <>
            <Row className="text-center">
              <h2 className="col">Humpty Dumpty Fall Scale (HDFS)</h2>
            </Row>
            <FallRiskAssessment
              currentAge={currentAge}
              patientVehicle={patientVehicle}
              HDFS={HDFS}
              setHDFS={setHDFS}
            />
          </>
        ) : (
          <>
            <Row className="text-center">
              <h2 className="col">Hendrich Fall Risk Assessment</h2>
            </Row>
            <FallRiskAssessmentAdult
              hendrich={hendrich}
              setHendrich={setHendrich}
            />
          </>
        )}
        <MyLines type="dashed" />
        {/* ================= PAIN SCORE =================  */}
        <Row className="text-center">
          <h2 className="col">Numerical Pain Scale</h2>
        </Row>
        <NumericalPainScale painScore={painScore} setPainScore={setPainScore} />
        <MyLines type="dashed" />
        {/* ================= VISIT FOLLOWUPS =================  */}

        <Row className="text-center">
          <h2 className="col">Follow-Up Measures </h2>
        </Row>
        <div>
          {clinic && (
            <div className="p-4">
              {visitFollowups?.map((f) => (
                <div key={f._id}>
                  <VisitFollowupForm followupItem={f} deleteItem={deleteItem} />
                </div>
              ))}
            </div>
          )}
          {/* <pre>{JSON.stringify(visitFollowups, null, 2)}</pre>
          <pre>{JSON.stringify(missedFollowups, null, 2)}</pre> */}

          {missedFollowups.map((m) => (
            <Button
              variant="info"
              className="w-100 my-2"
              onClick={() =>
                setVisitFollowups([
                  ...visitFollowups,
                  {
                    followupId: m._id,
                    followupLabel: m.label,
                    value: 0,
                  },
                ])
              }
            >
              <FaPlusCircle /> {`Add ${m.label}`}
            </Button>
          ))}
        </div>
        <MyLines type="dashed" />
        {/* ================= NURSE NOTE =================  */}

        <Row className="text-center">
          <h2 className="col"> Notes</h2>
        </Row>
        <TextEditor text={nurseNote} setText={setNurseNote} rtl={true} />
        <Row dir="rtl" className="g-3 text-center text-primary my-2">
          <Col
            className="my-2"
            md={3}
            onClick={() => setNurseNote((prev) => prev + nursingCarePlan)}
          >
            <Card className="h-100 shadow-sm border border-primary">
              <Card.Body>
                <Card.Text>
                  <MdFormatListBulleted /> إضافة نموذج خطة الرعاية التمريضية.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col
            className="my-2"
            md={3}
            onClick={() => setNurseNote((prev) => prev + criticalResultAlert)}
          >
            <Card className="h-100 shadow-sm border border-primary ">
              <Card.Body>
                <Card.Text>
                  <IoNotifications /> إضافة نموذج الإبلاغ عن النتائج الحرجة
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col
            className="my-2"
            md={3}
            onClick={() => setNurseNote((prev) => prev + fallingEventContent)}
          >
            <Card className="h-100 shadow-sm border border-primary ">
              <Card.Body>
                <Card.Text>
                  <FaPersonFalling /> إضافة نموذج تقييم سقوط مريض
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col
            className="my-2"
            md={3}
            onClick={() => setNurseNote((prev) => prev + codeBlue)}
          >
            <Card className="h-100 shadow-sm border border-primary ">
              <Card.Body>
                <Card.Text>
                  <TbActivityHeartbeat /> إضافة نموذج الإنعاش القلبي الرئوي
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col className="my-2" md={3} onClick={handleClear}>
            <Card className="h-100 shadow-sm border border-danger text-danger">
              <Card.Body>
                <Card.Text>
                  <FaRemoveFormat /> امسح الكل
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {/* ================= SUBMIT =================  */}
        {error && (
          <Message
            children={`Add Nurse Section Err: ${error}`}
            variant={`danger`}
            setMessage={setError}
          />
        )}
        {loading ? (
          <Loader />
        ) : (
          <Row className="width-100 justify-content-end my-2">
            <Col className="mr-2 col-auto">
              <Button
                variant="outline-success"
                onClick={() => addNurseSection()}
              >
                <AiOutlineSend /> ADD NURSE SECTION
              </Button>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

export default VisitNurseForm;
